var _defs, _path, _rect, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "LRM_EXPORT_21487740837581_20190512_134356503",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(733.83 326.83)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_110",
    "data-name": "Mask Group 110",
    transform: "translate(-733.83 -326.83)",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "LRM_EXPORT_21487740837581_20190512_134356503-2",
    "data-name": "LRM_EXPORT_21487740837581_20190512_134356503",
    d: "M23.922,0A23.922,23.922,0,1,1,0,23.922,23.922,23.922,0,0,1,23.922,0Z",
    transform: "translate(733.909 326.909)",
    fill: "#fff1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    "data-name": "Group 2688",
    transform: "translate(742.606 333.139)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 7.837,
    height: 2.886,
    transform: "translate(11.277 30.883)",
    fill: "#546cad"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    d: "M277.771,280.89H271.4s.161,4.02-.619,5.186h7.685C277.691,284.91,277.771,280.89,277.771,280.89Z",
    transform: "translate(-259.429 -253.393)",
    fill: "#f3a77a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4508",
    "data-name": "Path 4508",
    d: "M272.326,283.927a6.773,6.773,0,0,0,3.354.89,7.974,7.974,0,0,0,3.249-.727,25.819,25.819,0,0,1-.156-3.2h-6.367A25.512,25.512,0,0,1,272.326,283.927Z",
    transform: "translate(-260.43 -253.393)",
    fill: "#f3d3cc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M265.786,297.543l-9.242-3.311h-6.128l-9.242,3.311s-3.236,1.065-2.858,6.229h30.328C269.086,298.29,265.786,297.543,265.786,297.543Z",
    transform: "translate(-238.285 -262.072)",
    fill: "#f3a77a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4510",
    "data-name": "Path 4510",
    d: "M265.786,298.589l-7.552-2.705-4.749,3.311-4.638-3.354-7.672,2.748s-3.236,1.065-2.858,6.229h30.328C269.086,299.337,265.786,298.589,265.786,298.589Z",
    transform: "translate(-238.285 -263.119)",
    fill: "#2598d1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2680",
    "data-name": "Group 2680",
    transform: "translate(22.111 17.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4511",
    "data-name": "Path 4511",
    d: "M301.62,254.12c-.219,1.358.162,2.564.85,2.693s1.423-.863,1.641-2.221-.162-2.564-.851-2.694S301.839,252.763,301.62,254.12Z",
    transform: "translate(-301.558 -251.887)",
    fill: "#f3a77a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2679",
    "data-name": "Group 2679",
    transform: "translate(0.536 0.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2677",
    "data-name": "Group 2677",
    transform: "translate(0.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4512",
    "data-name": "Path 4512",
    d: "M304.092,254.737s.01-.076.037-.2a2.445,2.445,0,0,1,.166-.488c.086-.181.225-.39.4-.4a.378.378,0,0,1,.133.019c.007.005.053.023.067.035a.515.515,0,0,1,.049.041.7.7,0,0,1,.166.3,1.731,1.731,0,0,1,.081.385,1.885,1.885,0,0,1,0,.389c-.021.136-.028.276-.052.394s-.045.235-.066.34-.049.2-.068.292-.045.161-.062.224c-.035.124-.053.2-.053.2s.035-.062.093-.175c.027-.058.066-.125.1-.209s.074-.177.114-.281.072-.227.109-.354.056-.256.083-.394a1.822,1.822,0,0,0,.016-.465,2.052,2.052,0,0,0-.088-.46.958.958,0,0,0-.24-.4.509.509,0,0,0-.1-.071.775.775,0,0,0-.094-.038.551.551,0,0,0-.207-.01.543.543,0,0,0-.338.24,1.266,1.266,0,0,0-.163.34,2.175,2.175,0,0,0-.093.547A1.34,1.34,0,0,0,304.092,254.737Z",
    transform: "translate(-304.086 -253.399)",
    fill: "#f0926a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4513",
    "data-name": "Path 4513",
    d: "M303.7,256.9s-.064-.145.389-.179c0,0,.506.093.209.769a2.195,2.195,0,0,0-.152.455c-.045.226.036.534-.086.735-.157.259-.556.112-.579-.185a1.709,1.709,0,0,1,.323-.779A.606.606,0,0,0,303.7,256.9Z",
    transform: "translate(-303.342 -255.557)",
    fill: "#f0926a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2678",
    "data-name": "Group 2678",
    transform: "translate(0 2.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4514",
    "data-name": "Path 4514",
    d: "M303.228,261.71a.207.207,0,0,0-.035.037.442.442,0,0,0-.066.126.4.4,0,0,0-.023.1.354.354,0,0,0-.008.113c0,.038,0,.08.01.121a.934.934,0,0,0,.037.113.516.516,0,0,0,.051.1c.02.029.046.053.067.079a.29.29,0,0,0,.138.1.421.421,0,0,0,.154.039,1.015,1.015,0,0,0-.071-.165.462.462,0,0,0-.038-.064c-.011-.024-.019-.051-.033-.075a.573.573,0,0,0-.037-.071.344.344,0,0,1-.029-.076.788.788,0,0,1-.055-.148.65.65,0,0,1-.02-.075c0-.026-.015-.05-.017-.074C303.237,261.793,303.228,261.709,303.228,261.71Z",
    transform: "translate(-303.092 -261.71)",
    fill: "#f0926a"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684",
    transform: "translate(5.776 17.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4515",
    "data-name": "Path 4515",
    d: "M257.368,254.12c.219,1.358-.162,2.564-.849,2.693s-1.423-.863-1.641-2.221.162-2.564.851-2.694S257.15,252.763,257.368,254.12Z",
    transform: "translate(-254.815 -251.887)",
    fill: "#f3a77a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2683",
    "data-name": "Group 2683",
    transform: "translate(0.401 0.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2681",
    "data-name": "Group 2681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4516",
    "data-name": "Path 4516",
    d: "M257.287,254.737s-.01-.076-.037-.2a2.472,2.472,0,0,0-.166-.488c-.086-.181-.225-.39-.4-.4a.374.374,0,0,0-.132.019.6.6,0,0,0-.067.035.511.511,0,0,0-.049.041.7.7,0,0,0-.166.3,1.731,1.731,0,0,0-.081.385,1.887,1.887,0,0,0,0,.389c.021.136.027.276.052.394l.065.34c.028.106.05.2.069.292s.046.161.061.224c.036.124.053.2.053.2s-.035-.062-.093-.175c-.026-.058-.065-.125-.1-.209s-.074-.177-.114-.281-.071-.227-.108-.354a3.98,3.98,0,0,1-.083-.394,1.791,1.791,0,0,1-.017-.465,2.051,2.051,0,0,1,.088-.46.955.955,0,0,1,.24-.4.5.5,0,0,1,.1-.071.745.745,0,0,1,.094-.038.553.553,0,0,1,.208-.01.541.541,0,0,1,.338.24,1.254,1.254,0,0,1,.163.34,2.141,2.141,0,0,1,.093.547A1.322,1.322,0,0,1,257.287,254.737Z",
    transform: "translate(-255.964 -253.399)",
    fill: "#f0926a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4517",
    "data-name": "Path 4517",
    d: "M258.463,256.9s.064-.145-.39-.179c0,0-.506.093-.209.769a2.21,2.21,0,0,1,.152.455c.045.226-.036.534.086.735.157.259.556.112.579-.185a1.706,1.706,0,0,0-.323-.779A.606.606,0,0,1,258.463,256.9Z",
    transform: "translate(-257.139 -255.557)",
    fill: "#f0926a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2682",
    "data-name": "Group 2682",
    transform: "translate(1.216 2.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4518",
    "data-name": "Path 4518",
    d: "M259.77,261.71a.175.175,0,0,1,.035.037.418.418,0,0,1,.067.126.433.433,0,0,1,.024.1.345.345,0,0,1,.008.113c0,.038,0,.08-.011.121a1,1,0,0,1-.037.113.515.515,0,0,1-.051.1c-.02.029-.046.053-.067.079a.29.29,0,0,1-.138.1.421.421,0,0,1-.154.039,1.012,1.012,0,0,1,.071-.165.462.462,0,0,1,.038-.064c.011-.024.019-.051.032-.075a.525.525,0,0,1,.037-.071.363.363,0,0,0,.029-.076.784.784,0,0,0,.055-.148.65.65,0,0,0,.02-.075c0-.026.015-.05.017-.074C259.761,261.793,259.77,261.709,259.77,261.71Z",
    transform: "translate(-259.444 -261.71)",
    fill: "#f0926a"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4519",
    "data-name": "Path 4519",
    d: "M267.163,216.37v0h-.217c-5.471.049-8.545,1.607-7.7,11.58l.941,7.944a3.3,3.3,0,0,0,1.757,2.316l2.972,2.2a4.348,4.348,0,0,0,4.288,0l2.972-2.2a3.3,3.3,0,0,0,1.757-2.316l.992-7.76C275.759,218.159,272.634,216.418,267.163,216.37Z",
    transform: "translate(-251.829 -211.418)",
    fill: "#f3a77a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4520",
    "data-name": "Path 4520",
    d: "M274.49,257.613a8.333,8.333,0,0,1-.877,2.924,2.071,2.071,0,0,1-1.6.818,5.739,5.739,0,0,1-1.31-.09,6.678,6.678,0,0,0-1-.234,1.808,1.808,0,0,0-.981.3,1.45,1.45,0,0,1-1.229.061,5.622,5.622,0,0,0-1.909-.415,7.359,7.359,0,0,1-2.357,0,2.588,2.588,0,0,1-1.512-1.654c-.167-.391-.285-1.311-.4-1.715-.148-.5-.379-.157-.837-.162l.6,5.608a3.3,3.3,0,0,0,1.757,2.316l2.972,2.2a4.35,4.35,0,0,0,4.288,0l2.972-2.2a3.3,3.3,0,0,0,1.757-2.316l.657-5.7C274.964,257.341,274.626,257.025,274.49,257.613Z",
    transform: "translate(-252.724 -238.019)",
    fill: "#361709"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4521",
    "data-name": "Path 4521",
    d: "M270.323,249.621c0,.518.294.937.65.935s.642-.424.638-.943-.294-.937-.649-.935S270.32,249.1,270.323,249.621Z",
    transform: "translate(-259.127 -232.437)",
    fill: "#231208"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4522",
    "data-name": "Path 4522",
    d: "M270.4,250a.279.279,0,1,1-.279-.279A.278.278,0,0,1,270.4,250Z",
    transform: "translate(-258.813 -233.116)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4523",
    "data-name": "Path 4523",
    d: "M291.134,249.621c0,.518-.294.937-.649.935s-.642-.424-.639-.943.294-.937.65-.935S291.137,249.1,291.134,249.621Z",
    transform: "translate(-271.828 -232.437)",
    fill: "#231208"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4524",
    "data-name": "Path 4524",
    d: "M292.421,250a.279.279,0,1,0,.278-.279A.278.278,0,0,0,292.421,250Z",
    transform: "translate(-273.503 -233.116)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2686",
    "data-name": "Group 2686",
    transform: "translate(13.578 20.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2685",
    "data-name": "Group 2685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4525",
    "data-name": "Path 4525",
    d: "M279.761,261.959a1.819,1.819,0,0,1-.516.341,2.022,2.022,0,0,1-.618.168,1.832,1.832,0,0,1-.667-.033,1.83,1.83,0,0,1-.326-.1,2.773,2.773,0,0,1-.308-.149l-.128-.065-.029-.216a2.67,2.67,0,0,1-.024-.269c-.006-.088,0-.175,0-.262a2.98,2.98,0,0,1,.072-.518,2.322,2.322,0,0,1,.174-.5,1.83,1.83,0,0,1,.3-.468,2.46,2.46,0,0,1,.146.529,3.8,3.8,0,0,1,.062.5c.007.164.01.327,0,.489l-.015.242c-.006.079-.015.164-.024.236l-.156-.281c.07.042.132.1.205.137a1.794,1.794,0,0,0,.222.114,2.466,2.466,0,0,0,.238.089c.083.017.167.046.255.058a1.888,1.888,0,0,0,.268.028,2.482,2.482,0,0,0,.28,0A3.512,3.512,0,0,0,279.761,261.959Z",
    transform: "translate(-277.141 -259.888)",
    fill: "#e68e68"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4526",
    "data-name": "Path 4526",
    d: "M269.109,244.717a.451.451,0,0,1-.51.346,4.953,4.953,0,0,0-2.6.218.467.467,0,0,1-.556-.256h0a.413.413,0,0,1,.226-.581,5.857,5.857,0,0,1,3.066-.271.457.457,0,0,1,.377.544Z",
    transform: "translate(-255.92 -229.447)",
    fill: "#361709"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M287.1,244.717a.452.452,0,0,0,.511.346,4.954,4.954,0,0,1,2.6.218.467.467,0,0,0,.556-.256h0a.412.412,0,0,0-.226-.581,5.856,5.856,0,0,0-3.065-.271.457.457,0,0,0-.378.544Z",
    transform: "translate(-270.033 -229.447)",
    fill: "#361709"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M281.265,275.837a1.722,1.722,0,0,1-.77.012",
    transform: "translate(-265.745 -250.105)",
    fill: "none",
    stroke: "#e2826c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M276.631,271.278l.448.88a2.6,2.6,0,0,0,3.409-.835A34.994,34.994,0,0,1,276.631,271.278Z",
    transform: "translate(-263.231 -247.14)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M261.143,209.446s2.043,2.472,6.66,3.124c0,0,4.692,1.621,4.629,4.266l-.828,4.8.938-.1s.026-1.934,1.056-1.961c0,0,.928-3.882.913-4.547s-1.308-7.244-1.308-7.244l-5.031-3.588s-5.44-.8-7.966-1.994a4.541,4.541,0,0,0,1.418,1.994s-3.154.333-3.449.266.436,1.662.436,1.662l-2.649,4.054.511,9.4s.819.081,1.067,2.059h.769l-.135-6.03A21.631,21.631,0,0,1,261.143,209.446Z",
    transform: "translate(-249.786 -202.202)",
    fill: "#361709"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M260.935,216.61a12.476,12.476,0,0,1-2.351-3.06l-2.62,4.01v.024c.865,1.386,1.729,2.774,2.64,4.13a19.192,19.192,0,0,1,2.538-4.886,5.978,5.978,0,0,0,.821.761Q261.434,217.115,260.935,216.61Z",
    transform: "translate(-249.786 -209.584)",
    fill: "#260d00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M273.583,295.756l-.623-3.183-3.3-2-.48,2.007Z",
    transform: "translate(-258.386 -259.695)",
    fill: "#546cad"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M281.773,295.756l.623-3.183,3.3-2,.48,2.007Z",
    transform: "translate(-266.577 -259.695)",
    fill: "#546cad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2687",
    "data-name": "Group 2687",
    transform: "translate(13.145 33.309)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M279.536,297.521h-3.147a.961.961,0,0,0-.4,1.166l1,1.586h1.95l1-1.586A.961.961,0,0,0,279.536,297.521Z",
    transform: "translate(-275.908 -297.521)",
    fill: "#4c4291"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M279.751,297.7a1.732,1.732,0,0,1-.063.936,1.832,1.832,0,0,1-1.4,1.293,1.213,1.213,0,0,1-1.439-.8,1.727,1.727,0,0,1,.1-1.608h-.559a.961.961,0,0,0-.4,1.166l1,1.586h1.95l1-1.586A.885.885,0,0,0,279.751,297.7Z",
    transform: "translate(-275.908 -297.521)",
    fill: "#4c4291",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M276.979,305.4l-1.076,5.639h4.108L278.93,305.4Z",
    transform: "translate(-275.903 -302.644)",
    fill: "#4c4291"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4537",
    "data-name": "Path 4537",
    d: "M270,292.573l-1.559,2.855-3.81-2.589,2.072-2.262Z",
    transform: "translate(-255.422 -259.695)",
    fill: "#6ea6d4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4538",
    "data-name": "Path 4538",
    d: "M283.555,292.573l1.559,2.855,3.81-2.589-2.073-2.262Z",
    transform: "translate(-267.736 -259.695)",
    fill: "#6ea6d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e51fac653d7da09b2a0b83d682993fad.svg";
export { ForwardRef as ReactComponent };